import React, { useState } from "react";
import { Link } from "react-router-dom";
import MainContent from "@components/content";
import Timeline from "@components/timeline";
import css from "../index.module.css";

const timelineData = [
  {
    status: "ОВМ МВД России",
    date: "Февраль 2025",
    title: "Отказ в оформлении паспорта",
    color: "danger",
    description:
      "Фактический отказ в приеме документов на загранпаспорт от эмансипированного несовершеннолетнего из-за отсутствия родителей.",
  },
  {
    status: "Досудебный порядок",
    date: "Февраль 2025",
    title: "Подача ведомственных жалоб",
    color: "default",
    description:
      "Направление официальных жалоб руководству МВД на незаконные действия сотрудников миграционного отдела.",
  },
  {
    status: "МВД / Прокуратура",
    date: "Март 2025",
    title: "Отказ в удовлетворении жалоб",
    color: "danger",
    description:
      "Ведомство и прокуратура не усмотрели нарушений и отказались применять меры прокурорского и ведомственного реагирования.",
  },
  {
    status: "Щёлковский городской суд",
    date: "Май 2025",
    title: "Подача административного иска",
    color: "warning",
    description:
      "Подано административное исковое заявление (в порядке КАС РФ) о признании незаконным отказа в предоставлении государственной услуги.",
  },
  {
    status: "Щёлковский городской суд",
    date: "18 июля 2025",
    title: "Победа в первой инстанции",
    color: "success",
    description:
      "Суд признал отказ МВД незаконным, подтвердил самостоятельное право эмансипированного на получение паспорта и взыскал моральный вред.",
  },
  {
    status: "Министерство внутренних дел Российской Федерации",
    date: "Сентябрь 2025",
    title: "Апелляционная жалоба",
    color: "danger",
    description:
      "Ответчик не согласился с решением суда первой инстанции и направил апелляционную жалобу.",
  },
  {
    status: "Московский областной суд",
    date: "14 января 2026",
    title: "Победа в апелляционной инстанции",
    color: "success",
    description:
      "Решение суда оставлено в силе в основной части (изменена лишь сумма моральной компенсации). Отказ окончательно признан незаконным.",
  },
  {
    status: "Щёлковский городской суд",
    date: "Февраль 2026",
    title: "Исполнительный лист",
    color: "success",
    description:
      "Получен исполнительный документ для принудительного взыскания компенсации морального вреда.",
  },
  {
    status: "МВД России",
    date: "Март 2026",
    title: "Официальные извинения и исполнение решения",
    color: "success",
    description:
      "Министерство внутренних дел Российской Федерации официально принесло извинения за допущенные нарушения и приступило к исполнению вступившего в законную силу решения суда.",
  },
  {
    status: "Первый кассационный суд общей юрисдикции",
    date: "Июнь 2026",
    title: "Кассационная жалоба",
    color: "danger",
    description:
      "Министерство внутренних дел Российской Федерации подало кассационную жалобу на решение Щелковского городского суда и Судебной коллегии Московского областного суда.",
  },
];

const initialCaseStatus = {
  label: "В производстве",
  code: "in_progress",
  variant: "in_progress",
};

const LegalCase1Page = () => {
  const [caseStatus] = useState(initialCaseStatus);

  return (
    <MainContent>
      <div className={css.casePage}>
        <div className={css.caseHeader}>
          <div className={css.caseHeaderTop}>
            <Link to="/legal" className={css.backLink}>
              <span className={css.backIcon}>←</span>
              <span>Назад к делам</span>
            </Link>
            <div
              className={`${css.caseStatus} ${css[`caseStatus_${caseStatus.variant}`]
                }`}
            >
              <span className={css.caseStatusDot} />
              <span className={css.caseStatusText}>{caseStatus.label}</span>
            </div>
          </div>
          <h1>Отказ в выдаче заграничного паспорта</h1>
          <span className={css.caseMeta}>
            Права несовершеннолетних · 2025 г.
          </span>
        </div>

        <div className={css.caseLayout}>
          <div className={css.caseDescription}>
            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Суть (фабула)</div>
              <p>
                Административный истец, который ранее был официально объявлен полностью дееспособным (эмансипированным) на основании решения об эмансипации, обратился в Отдел по вопросам миграции территориального органа МВД с заявлением о выдаче заграничного паспорта нового поколения. Должностное лицо Ответчика приняло заявление, но фактически отказало в его дальнейшем оформлении, вернув документы под предлогом необходимости присутствия законных представителей.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Позиция истца</div>
              <p>
                Истец указывает, что он объявлен полностью дееспособным. В соответствии со статьей 27 Гражданского кодекса РФ, он обладает всеми гражданскими правами и обязанностями в полном объеме. Федеральное законодательство не устанавливает специального возрастного ценза для получения загранпаспорта, который бы ограничивал права эмансипированного лица
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Позиция ответчика</div>
              <p>
                Ответчик исковые требования не признал и просил отказать в их удовлетворении.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Решение суда</div>
              <p>
                Суд первой инстанции частично удовлетворил административный иск. Признал незаконными действия должностного лица Ответчика, выразившиеся в отказе в приеме и рассмотрении заявления. Суд указал, что федеральный закон не устанавливает специального возрастного ценза для получения загранпаспорта, а значит, эмансипированный гражданин вправе подавать документы и получать паспорт самостоятельно.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Итог (резюме)</div>
              <p>Решение Щелковского городского суда вступило в законную силу. Действия ОВМ МУ МВД России, выразившиеся в фактическом отказе принять заявление на загранпаспорт от эмансипированного несовершеннолетнего, признаны незаконными.</p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Правовые последствия</div>
              <p>На уровне апелляционной инстанции закреплен прецедент, подтверждающий, что эмансипированный несовершеннолетний в возрасте от 16 до 18 лет обладает правами в полном объеме и может самостоятельно подавать заявление на выдачу заграничного паспорта.</p>
              <p style={{ marginTop: 10 }}>Суды подтвердили, что Федеральный закон № 114-ФЗ «О порядке выезда из РФ...» не устанавливает возрастных ограничений, которые препятствовали бы полностью дееспособному (эмансипированному) лицу получать загранпаспорт без участия родителей.</p>
              <p style={{ marginTop: 10 }}>Довод ответчика о том, что ведомственная система «Мир» технически не позволяет ввести данные несовершеннолетнего без указания законного представителя, де-факто признан несостоятельным. Внутренние технические проблемы государственного органа не могут ограничивать права граждан.</p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle} style={{ margin: 0 }}>Материалы</div>
              <div className={css.caseMaterialsList}>
                <a href="https://dash.leecyber.com/drive/shared/4e4f4e84-7c99-4493-8519-20fd825038f9" className={css.caseMaterialLink} target="_blank" rel="noreferrer">
                  Решение Щёлковского городского суда
                </a>
                <a target="_blank" href="https://shelkovo--mo.sudrf.ru/modules.php?name=sud_delo&srv_num=1&name_op=case&case_id=929130746&case_uid=e74827f7-afb9-47d2-9b56-a4ee61f8e22c&delo_id=41" className={css.caseMaterialLink} download>
                  Карточка дела в Щёлковском городском суде
                </a>
              </div>
            </div>
          </div>

          <div className={css.caseTimeline}>
            <div className={css.caseSectionTitle} style={{ marginBottom: 25 }}>Ход дела</div>
            <Timeline data={timelineData} />
          </div>
        </div>
      </div>

      <p className={css.caseDisclaimer}>Все представленные дела — результат моей самостоятельной практики. Опубликованные материалы не являются профессиональной юридической консультацией, носят исключительно ознакомительный характер и отражают мое субъективное мнение.</p>
    </MainContent>
  );
};

export default LegalCase1Page;

